import request from '@/utils/request'
import {applicationName} from '@/utils/const.js'


export default {
  viewUserNum(){
    return request({
      url:applicationName+'/admin/userInfo/userViewNum',
      method:'Get',
    })
  },
  viewModelNum(){
    return request({
      url:applicationName+'/admin/userInfo/modelViewNum',
      method:'Get',
    })
  },
}